// src/reducers/index.js
import { combineReducers } from 'redux';
import sessionReducer from './sessionReducer';
import programReducer from './programReducer';
import { LOGOUT } from '../actions/actionTypes';
import customerReducer from './customerReducer';
const appReducer = combineReducers({
    session: sessionReducer,
    program: programReducer,
    customer: customerReducer
});
const rootReducer = (state: any, action: any) => {
    // 退出时候清空state
    if (action.type === LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
